module.exports = __webpack_public_path__ + "static/media/mbs_4.7530787b.jpg";